import { apiSlice } from '../api/apiSlice';
import {
  GetBannerParams,
  GetBannerResponse,
  GetPromotionsParams,
  GetPromotionsResponse,
} from './promotionApiSliceTypes';

const countryApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPromotions: builder.query<GetPromotionsResponse, GetPromotionsParams>({
      query: (params) => ({
        url: '/promotions',
        method: 'GET',
        headers: {
          'Accept-Language': params.acceptLanguage ?? 'en',
        },
      }),
    }),

    getBanner: builder.query<GetBannerResponse, GetBannerParams>({
      query: (params) => ({
        url: '/promotions/banner',
        method: 'GET',
        headers: {
          'Accept-Language': params.acceptLanguage ?? 'en',
        },
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetBannerQuery,
  useGetPromotionsQuery,
  useLazyGetBannerQuery,
  useLazyGetPromotionsQuery,
} = countryApiSlice;
